import Component from './components/Reports';
import { PATH } from './constants';

export { PATH };
export default Component;
